import { render, staticRenderFns } from "./BasicInfoView.vue?vue&type=template&id=48359bc1&scoped=true&"
import script from "./BasicInfoView.vue?vue&type=script&lang=js&"
export * from "./BasicInfoView.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoView.vue?vue&type=style&index=0&id=48359bc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48359bc1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChip,VCol,VRow,VTooltip})
